import { gql } from "@apollo/client";
import { fragments as notesWrapperOrderFragment } from "../../components/NotesWrapper/graph";

const addArtNoteToOrderMutation = gql`
  mutation($orderId: ID!, $note: String!) {
    addArtNoteToOrder(orderId: $orderId, note: $note) {
      errors {
        orderId
        note
      }
      updatedOrder {
        ...NotesWrapper_order
      }
      succeeded
    }
  }
  ${notesWrapperOrderFragment.order}
`;

export default addArtNoteToOrderMutation;
